exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---c_-jl {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n  padding: 16px 0;\n  border-radius: 8.649px;\n  background: #fff;\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n          box-shadow: 0 4px 5px 0 rgba(0, 102, 116, .25);\n  text-align: center;\n  color: #595959;\n  margin-left: 10px; }\n  @media (min-width: 992px) {\n    .component---c_-jl {\n      padding: 24px 0; } }\n", ""]);

// exports
exports.locals = {
	"component": "component---c_-jl"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./components/live-points/live-points.scss
// module id = eqXO
// module chunks = 1